import React, {
    useRef,
    useState,
    useEffect
} from 'react';

import {
    useSelector
} from 'react-redux';

import useCloseElement from '../../Hooks/useCloseElement.js';

// css
import {
    Icon,
    Item,
    NavMenu,
    NavBar,
    MenuText,
    NavMenuItems,
    BtnCerrar
} from '../Css/StyledHeader.js';


const Sidebar = () => {

    const wrapperRef = useRef();
    const [estadoClose] = useCloseElement(wrapperRef);
    const [sidebar, setSidebar] = useState(false);

    /*
    ====================================
    ROL DEL USUARIO
    ====================================

    Estadísticas y cobros pertenece
    actualmente al rol profesional.
    ====================================
    */

    const rol = useSelector((state) => state.usuario?.rol);

    const showSidebar = () => setSidebar(!sidebar);

    useEffect(() => {

        if (estadoClose) {
            setSidebar(false);
        }

    }, [estadoClose]);

    return (

        <div ref={wrapperRef}>

            <NavBar>

                <Icon
                    src={`/img/menu.svg`}
                    alt="barra lateral"
                    width="1.5rem"
                    margin="0"
                    padding="0 2rem 0 0.5rem"
                    onClick={showSidebar}
                />

            </NavBar>


            <NavMenu sidebar={sidebar}>

                <NavMenuItems>

                    <BtnCerrar
                        src={`/img/cerrar.svg`}
                        alt="x cerrar"
                        onClick={showSidebar}
                    />

                    <MenuText>
                        <Item to={'/escritorio/calendario'} >
                            <Icon
                                src={`/img/calendario.svg`}
                                alt=""
                                width="15px"
                                margin="0px 10px"
                            />
                            Calendario
                        </Item>
                    </MenuText>

                    <MenuText>
                        <Item to={'/escritorio/pacientes'} >
                            <Icon
                                src={`/img/pacientes.svg`}
                                alt=""
                                width="22px"
                                margin="0px 10px"
                            />
                            Pacientes
                        </Item>
                    </MenuText>

                    <MenuText>
                        <Item to={'/escritorio/miperfil'}>
                            <Icon
                                src={`/img/pacientes.svg`}
                                alt=""
                                width="20px"
                                margin="0px 10px"
                            />
                            Mi perfil
                        </Item>
                    </MenuText>

                    <MenuText>
                        <Item to={'/escritorio/tutoriales'}>
                            <Icon
                                src={`/img/pacientes.svg`}
                                alt=""
                                width="20px"
                                margin="0px 10px"
                            />
                            Tutoriales
                        </Item>
                    </MenuText>

                    <MenuText>

                            <Item to={'/escritorio/exportar-historias-clinicas'}>

                                <Icon
                                    src={`/img/pacientes.svg`}
                                    alt=""
                                    width="20px"
                                    margin="0px 10px"
                                />

                                Exportar historias clínicas

                            </Item>

                    </MenuText>

                    {String(rol) === '489431' ? (
                        <MenuText>
                            <Item to={'/escritorio/pacientes/paciente/estadisticas'}>
                                {/*
                                Por ahora reutilizamos un ícono
                                existente para no depender de
                                un archivo que todavía no existe.

                                Después podemos crear:
                                /img/estadisticas.svg
                                */}
                                <Icon
                                    src={`/img/pacientes.svg`}
                                    alt=""
                                    width="20px"
                                    margin="0px 10px"
                                />
                                Estadísticas y cobros
                            </Item>
                        </MenuText>

                    ) : null}

                </NavMenuItems>

            </NavMenu>

        </div>

    );

};


export default Sidebar;